module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial3@2x_0371c8.jpg";